<template>

  <div>

    <el-form v-model="form" v-if="form" label-position="left">

      <check-box prop="showAdvanced" v-model="showAdvanced">Advanced</check-box>


      <el-row>

        <el-col :sm="24" :md="14">
          <select-data-type label="" v-model="form.dataType" prop="dataType" />
        </el-col>

        <el-col :sm="24" :md="7" :push="1">
          <number-input v-if="form.dataType === 'Number'" :min="0" :max="5" placeholder="Decimals" prop="decimals" v-model="form.decimals" />
        </el-col>

      </el-row>

      <br />

      <el-row v-if="!(form.dataType === 'el-row' || form.dataType === 'el-col')">

        <el-col :sm="24" :md="14">
          <text-input placeholder="Label" v-model="form.label" prop="label" />
        </el-col>

        <el-col :sm="24" :md="7" :push="1">
          <check-box prop="required" v-model="form.required">Required</check-box>
        </el-col>

      </el-row>


      <br />

      <div v-if="form.dataType === 'select-input'">

        <select-input placeholder="List" v-model="form.list" filterable create return-list />
        <center>- or -</center>
        <br />
        <text-input placeholder="URL" v-model="form.url" />

      </div>

      <html-input v-if="form.dataType === 'text-area'" label="Text" prop="label" width="528px" v-model="form.label" />
      <text-input v-if="form.dataType === 'file-upload'" label="URL" prop="url" v-model="form.url" />

      <number-input v-if="form.dataType === 'number-input'" :min="0" :max="2" label="Decimals" prop="decimals" v-model="form.decimals" />

      <number-input v-if="form.dataType === 'el-row'" :min="0" :max="24" label="Gutter" prop="gutter" v-model="form.gutter" />
      <number-input v-if="form.dataType === 'el-col'" :min="0" :max="24" label="Span" prop="span" v-model="form.span" />

      <number-input v-if="showAdvanced" :min="0" :max="2" label="Offset" prop="offset" v-model="form.offset" />
      <check-box v-if="showAdvanced" label="Disabled" prop="disabled" v-model="form.disabled" />

    </el-form>

  </div>

</template>

<script>

import SelectDataType from '@/components/atoms/forms/SelectDataType'

export default {
  name: 'form-editor',

  components: {
    SelectDataType
  },

  props: {
    title: {
      type: String,
      default: 'Add Form Item'
    },

    value: {
      required: true
    },

  },


  watch: {
    value: function (v) {
      this.form = v
    }
  },

  data () {
    return {
      form: this.value,
      showAdvanced: false
    }
  },

}

</script>



// WEBPACK FOOTER //
// FormEditor.vue?67a22fba